import { render, staticRenderFns } from "./JogadoresPermissoes.vue?vue&type=template&id=8df1e342&"
import script from "./JogadoresPermissoes.vue?vue&type=script&lang=js&"
export * from "./JogadoresPermissoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports